import React from 'react';
import { motion } from 'framer-motion';
import { PawTrail } from './PawTrail';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section id="top" className="relative overflow-hidden bg-cream pb-2 pt-10 sm:pt-14" data-id="element-63" data-mp="ehtjpxlbn3oc">
      <PawTrail count={4} className="absolute left-[6%] top-16 hidden lg:flex" data-id="element-64" data-mp="9l33na9io82x" />
      <PawTrail count={3} className="absolute right-[7%] top-24 hidden lg:flex" tone="gold" data-id="element-65" data-mp="4n1oh0f7oswq" />

      <div className="mx-auto max-w-3xl px-5 text-center sm:px-8" data-id="element-66" data-mp="12861s1aa6gsn">
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.26,
        ease
      }} className="font-sans text-sm font-semibold text-gold-dark" data-id="element-67" data-mp="x9urjpg2q49w">
          Una app para empezar tu negocio de cuidado y paseo de perros
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease,
        delay: 0.05
      }} className="mt-4 font-display text-[2.25rem] font-semibold leading-[1.06] tracking-tight text-petrol sm:text-5xl lg:text-[3.75rem]" data-id="element-68" data-mp="3d2l9jc5qb50p">
          Aprendé a trabajar con perros y armá tu propio servicio.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease,
        delay: 0.1
      }} className="mx-auto mt-5 max-w-2xl font-sans text-lg leading-relaxed text-petrol/75" data-id="element-69" data-mp="399bc1q3avhx1">
          Pawsy Emprende te guía desde los primeros pasos hasta tener tus servicios, precios, perfil
          y herramientas para empezar a trabajar.
        </motion.p>
      </div>
    </section>;
}